// Information panels use normal document flow so resized content and open FAQs
// never inherit a carousel's stale width, translation, or fixed height.
(() => {
  function initialize(root) {
    if (root.dataset.tabsReady) return;
    const navigation = root.querySelector('.explore__nav');
    const buttons = Array.from(navigation.querySelectorAll('button'));
    const panels = Array.from(root.querySelectorAll('[data-product-panel]'));
    if (!buttons.length || buttons.length !== panels.length) return;
    root.dataset.tabsReady = 'true';
    navigation.setAttribute('role', 'tablist');
    const heading = root.querySelector('h2');
    if (heading) {
      heading.id = `${root.id}-heading`;
      navigation.setAttribute('aria-labelledby', heading.id);
    }

    function select(index, focus = false) {
      buttons.forEach((button, position) => {
        const selected = position === index;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        panels[position].hidden = !selected;
      });
      if (focus) buttons[index].focus();
    }

    buttons.forEach((button, index) => {
      const panel = panels[index];
      button.type = 'button';
      button.id = `${root.id}-tab-${index}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', `${root.id}-panel-${index}`);
      panel.id = `${root.id}-panel-${index}`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', button.id);
      panel.tabIndex = 0;
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        select(next, true);
      });
    });
    select(Math.max(0, buttons.findIndex(button => button.classList.contains('is-active'))));
  }

  function initializeAll() {
    document.querySelectorAll('[data-product-information]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
